import React from "react";

const SaveAsScDicomButton = ({ viewportIndex, handleUploadScDicom }) => {
  return (
    <div>
      <span
    onClick={() => handleUploadScDicom(viewportIndex)}
      title="Save viewport content as Secondary Capture DICOM"
    >
      <span className="secondary-capture-button"> </span>
    </span>
    </div>
  );
};

export default SaveAsScDicomButton;
